export enum enumEntrySummarySubmissionType {
  MANUAL = 0,
  BROKER_ASSISTED = 1,
}
